import React from 'react';
import './BulletedRuleDescription.styl';
import chunk from 'lodash/chunk';

/**
 * Component to render the humanized description of a rule.
 *
 * Similar, yet different, from BulletedMatchedRuleDescription.  If you make changes here,
 * check that component too.
 */
export default class BulletedRuleDescription extends React.PureComponent {
  render() {
    const parts = this.props.text.split(/(\bAND\b|;)/g);
    const actionNames = this.props.actionNames || [];
    const numActions = actionNames.length;
    const timing = this.props.timing && this.props.timing.split('AND');
    const pairs = chunk(parts.slice(1), 2);

    return timing ? (
      <div className="bulleted-rule-wrapper">
        Event:
        <div className="event-description ">
          <div>{parts[0].trim()}</div>
          <ul>
            {pairs.map((part, i) => (
              <li key={i} className={part[0] === 'AND' ? 'and-item' : 'or-item'}>
                <div>
                  {part[0] === 'AND' ? 'and ' : ''}
                  {part[1].trim()}
                </div>
              </li>
            ))}
          </ul>
        </div>
        {!timing && numActions > 0 && (
          <div>
            then
            <ul>
              {actionNames.map((part, i) => (
                <li key={i}>{part.trim()}</li>
              ))}
            </ul>
          </div>
        )}
        {timing && (
          <div>
            Trend Occurrence:
            <div className="timing-description">
              <div>{timing[0].trim()}</div>
              <ul>
                {timing.slice(1).map((part, i) => (
                  <li key={i}>
                    {i === 0 ? '' : 'and '}
                    {part.trim()}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    ) : (
      <div className="bulleted-rule-wrapper">
        <div>{parts[0].trim()}</div>
        <ul>
          {pairs.map((part, i) => (
            <li key={i} className={part[0] === 'AND' ? 'and-item' : 'or-item'}>
              <div>
                {part[0] === 'AND' ? 'and ' : ''}
                {part[1].trim()}
              </div>
            </li>
          ))}
        </ul>
        {numActions > 0 && (
          <div>
            then
            <ul>
              {actionNames.map((part, i) => (
                <li key={i}>{part.trim()}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}
